import L from "leaflet";
import area_blue from "./area-blue.svg";
import area_green from "./area-green.svg";
import area_red from "./area-red.svg";
import point_blue from "./point-blue.svg";
import point_green from "./point-green.svg";
import point_red from "./point-red.svg";
import range_blue from "./range-blue.svg";
import range_green from "./range-green.svg";
import range_red from "./range-red.svg";
import subarea_blue from "./subarea-blue.svg";
import subarea_green from "./subarea-green.svg";
import subarea_red from "./subarea-red.svg";

import rangeRedPerson from "./range-red-person.svg";
import rangeGreenPerson from "./range-green-person.svg";
import rangeBluePerson from "./range-blue-person.svg";

import areaRedPerson from "./area-red-person.svg";
import areaBluePerson from "./area-blue-person.svg";
import areaGreenPerson from "./area-green-person.svg";

import subareaRedPerson from "./subarea-red-person.svg";
import subareaBluePerson from "./subarea-blue-person.svg";
import subareaGreenPerson from "./subarea-green-person.svg";

import pointRedPerson from "./point-red-person.svg";
import pointBluePerson from "./point-blue-person.svg";
import pointGreenPerson from "./point-green-person.svg";

export function getIcon(color, kind) {
  console.log("getIcon, color:", color, ", kind:", kind);
  const key = `${kind}_${color}`;
  const iconMap = {
    point_red: point_red,
    point_blue: point_blue,
    point_green: point_green,
    subarea_red: subarea_red,
    subarea_blue: subarea_blue,
    subarea_green: subarea_green,
    area_red: area_red,
    area_blue: area_blue,
    area_green: area_green,
    range_red: range_red,
    range_blue: range_blue,
    range_green: range_green,
  };
  return new L.Icon({
    iconUrl: iconMap[key],
    iconSize: [35, 35],
    iconAnchor: [0, 0],
  });
}

export function getIcon2(iconName) {
  console.log("XX, getIcon, iconName:", iconName);
  const iconMap = {
    point_red: point_red,
    point_blue: point_blue,
    point_green: point_green,
    subarea_red: subarea_red,
    subarea_blue: subarea_blue,
    subarea_green: subarea_green,
    area_red: area_red,
    area_blue: area_blue,
    area_green: area_green,
    range_red: range_red,
    range_blue: range_blue,
    range_green: range_green,
    range_red_person: rangeRedPerson,
    range_blue_person: rangeBluePerson,
    range_green_person: rangeGreenPerson,

    area_red_person: areaRedPerson,
    area_blue_person: areaBluePerson,
    area_green_person: areaGreenPerson,

    subarea_red_person: subareaRedPerson,
    subarea_blue_person: subareaBluePerson,
    subarea_green_person: subareaGreenPerson,

    point_red_person: pointRedPerson,
    point_blue_person: pointBluePerson,
    point_green_person: pointGreenPerson,
  };

  return new L.Icon({
    iconUrl: iconMap[iconName],
    iconSize: [35, 35],
    iconAnchor: [0, 0],
  });
}
